import { render } from "./PDFPreview.vue?vue&type=template&id=4196baf9&scoped=true"
import script from "./PDFPreview.vue?vue&type=script&lang=js"
export * from "./PDFPreview.vue?vue&type=script&lang=js"

import "./PDFPreview.vue?vue&type=style&index=0&id=4196baf9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4196baf9"]])

export default __exports__